import { createClient } from '@supabase/supabase-js';
import secureLog from '../../util/secureLogger';
import { getConfig } from '../../util/secureConfig';

// Get Supabase config from secure config
const supabaseUrl = getConfig('supabase.url');
const supabaseAnonKey = getConfig('supabase.anonKey');

// Create the functions URL without logging it
const functionsUrl = supabaseUrl ? supabaseUrl.replace('.co', '.functions.supabase.co') : '';

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    functions: {
      url: functionsUrl
    }
  }
);

// Log initialization without exposing sensitive data
secureLog.debug('Supabase client initialized'); 
